import { useEffect } from "react";
// my imports:
import UI from "@/app/lib/ui/ui";
    
    // tOUCH / MOBILE CHECK
    // check if we are mobile width or not
    // ONLY RETURNS TRUE if below breakpoint width AND mobile device

export function useTouchCheck(ui: UI, useBreakPointWidth: boolean) {

    useEffect(() => {

        // UP HERE WE CHECK BREAKPOINT WIDTH
        const breakPointVarName: string = "--mobile-breakpoint";
        // get the breakpoint from css
        const breakPointWidth = getComputedStyle(document.documentElement)
            .getPropertyValue(breakPointVarName)
            .trim();
        
        if (useBreakPointWidth && !breakPointWidth) {
            console.warn(`CSS variable ${breakPointVarName} not found or empty. Can't do a mobile check in setup.`);
            return;
        }

        const mediaQuery = window.matchMedia(`(max-width: ${breakPointWidth})`);

        // this goes through multiple methods in preferential order, to check how the device identifies
        function detectMobileDevice() : boolean {
            // Modern client hints
            if ((navigator as any).userAgentData?.mobile !== undefined) {
                return (navigator as any).userAgentData.mobile;
            }

            // Try touch capability (can be spoofed by dev tools, allegedly, but not working)
            if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
                return true;
            }

            // Try a media query via pointer
            if (window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
                return true;
            }

            // Last chance, use regex
            return (
                typeof navigator !== 'undefined'
                && /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
                    .test(navigator.userAgent)
            )
        }

        // a parameter-less call to the updater that we can pass to the listener
        const setMobile = () => {
            const passesBreakPoint = useBreakPointWidth
                ? mediaQuery.matches
                : true;

            ui.setMobile(passesBreakPoint && detectMobileDevice());
        };

        // run it once, to start
        setMobile();
        // tell a listener to run it again on change
        mediaQuery.addEventListener("change", setMobile);

        return (
            () => mediaQuery.removeEventListener("change", setMobile)
        )
    }, []);
}